export const en = {
  details: 'Info',
  comments: 'Comments',
  session: 'Session',
  integrations: 'Integrations',
  refresh: 'refresh'
};

export type Translations = typeof en;
